import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

const ProfitlossChart = ({ data }) => {
  const [activeTab, setActiveTab] = useState("Win");

  // console.log("data?.Long_chart?.balance", data?.Long_chart?.balance);

  // const chartData = activeTab === "Win" ? data?.duration : data?.duration;

  const series =
    activeTab === "Win"
      ? [
          {
            name: "Average Profit",
            data: data?.chart?.profits || [],
          },
        ]
      : [
          {
            name: "Average Loss",
            data: data?.chart?.losses || [],
          },
        ];

  const options = {
    chart: {
      type: "area",
      zoom: { enabled: false },
      toolbar: { show: false },
      fontFamily: "Outfit, sans-serif",
    },
    colors: activeTab === "Win" ? ["#0D56EB"] : ["#FD504F"],
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        type: "vertical",
        shadeIntensity: 0.5,
        gradientToColors: activeTab === "Win" ? ["#0D56EB"] : ["#FD504F"],
        opacityFrom: 0.8,
        opacityTo: 0.3,
        stops: [0, 100],
      },
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    dataLabels: { enabled: false },
    grid: { borderColor: "#393939", strokeDashArray: 0 },
    xaxis: {
      labels: {
        rotate: -45,
        style: { colors: "#8B8E93", fontSize: "12px" },
      },
      categories: data?.chart?.duration || [],
    },
    yaxis: {
      labels: {
        style: { colors: "#8B8E93", fontSize: "12px" },
      },
    },
    legend: {
      show: false,
      fontSize: "14px",
      fontWeight: 700,
      labels: { colors: "white" },
      markers: { width: 15, height: 15 },
    },
    tooltip: { enabled: true },
  };

  return (
    <div id="chart">
      {/* Tabs */}
      <div className="area_chart_tabination">
        <button
          onClick={() => setActiveTab("Win")}
          className={`${activeTab === "Win" ? "Win" : ""}`}
        >
          Win
        </button>
        <button
          className={`${activeTab === "Loss" ? "Win" : ""}`}
          onClick={() => setActiveTab("Loss")}
        >
          Loss
        </button>
      </div>

      <div className="area_chart">
        <ReactApexChart
          options={options}
          series={series}
          type="area"
          height={240}
        />
      </div>
    </div>
  );
};

export default ProfitlossChart;
